import { http } from '@/services/api/client';
import type {
  CreateUserPayload,
  QueryUsersParams,
  UpdateUserPayload,
  UserPageResult,
  UserRecord,
} from '@/types/user';

export async function fetchUsers(params: QueryUsersParams): Promise<UserPageResult> {
  return http.get('/users', { params }) as Promise<UserPageResult>;
}

export interface DelegationCandidate { id: string; name: string; departmentId: string }

export async function fetchDelegationCandidates(departmentId: string): Promise<DelegationCandidate[]> {
  return http.get('/users/delegation-candidates', { params: { departmentId } }) as Promise<DelegationCandidate[]>;
}

export async function fetchDirectSubordinates(): Promise<UserRecord[]> {
  return http.get('/users/subordinates/direct') as Promise<UserRecord[]>;
}

export async function fetchUser(id: string): Promise<UserRecord> {
  return http.get(`/users/${id}`) as Promise<UserRecord>;
}

export async function createUser(payload: CreateUserPayload): Promise<UserRecord> {
  return http.post('/users', payload) as Promise<UserRecord>;
}

export async function updateUser(id: string, payload: UpdateUserPayload): Promise<UserRecord> {
  return http.patch(`/users/${id}`, payload) as Promise<UserRecord>;
}

export async function deleteUser(id: string): Promise<{ success: true }> {
  return http.delete(`/users/${id}`) as Promise<{ success: true }>;
}
